import { render, staticRenderFns } from "./ImportUrl.vue?vue&type=template&id=57ddd28c"
import script from "./ImportUrl.vue?vue&type=script&lang=js"
export * from "./ImportUrl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports